exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-container[data-v-44a3446b]{height:100%}.page-container .changePwd[data-v-44a3446b]{padding:20px 50px;background-color:#fff;border-radius:6px;margin-top:20px}.page-container .form-footer[data-v-44a3446b]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44a3446b","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/system/baseInfoManage/changePassword.vue
// module id = FZwa
// module chunks = 1